<template>
  <div>
    <v-container fluid class="pa-2">
      <!-- Header -->
      <div class="d-flex align-center justify-space-between mb-4">
        <div>
          <h2 class="section-title">
          {{$t('DriverManagement.DriverManagementTitle')}}
          </h2>
          <div class="text-h6 font-weight-bold"></div>
          <div class="text-caption grey--text">
          </div>
        </div>
        <div class="d-flex align-center" style="gap: 12px;">
          <v-btn color="primary" @click="openCreateInterface">
            <v-icon left>mdi-plus</v-icon>
            {{$t('DriverManagement.buttonNewInterface')}}
          </v-btn>

          <v-text-field
            v-model="search"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-magnify"
            placeholder="Search"
            style="width: 320px;"
          />
        </div>
      </div>

      <!-- Card -->
      <v-card class="table-card" outlined>
        <v-data-table
          :headers="getheaders"
          :items="filteredItems"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          class="elevation-1"
          hide-default-footer
        >
          <!-- # -->
          <template v-slot:item.no="{ index }">
            {{ (page - 1) * itemsPerPage + index + 1 }}
          </template>

          <!-- Actions (อยู่แถวเดียวกัน) -->
          <template v-slot:item.actions="{ item }">
            <div class="action-inline">
              <v-btn icon small text elevation="0" color="primary" @click="openEditInterface(item)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>

              <v-btn icon small text elevation="0" color="red" @click="confirmDeleteDriver(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>

          <!-- Status -->
          <!-- <template v-slot:item.isActive="{ item }">
            <v-chip
              small
              :color="item.isActive ? 'green' : 'red'"
              text-color="white"
              class="status-chip"
            >
              {{ item.isActive ? 'Active' : 'Inactive' }}
            </v-chip>
          </template> -->

          <!-- Transport Type เป็น chip -->
          <!-- <template v-slot:item.interfaceType="{ item }">
            <v-chip
              small
              class="mr-1"
              :color="transportColor(item.interfaceType)"
              text-color="white"
            >
              {{ item.interfaceType || '-' }}
            </v-chip>
          </template> -->

          <!-- Description -->
          <!-- <template v-slot:item.description="{ item }">
            <span class="grey--text text--darken-2">
              {{ item.description || "-" }}
            </span>
          </template> -->

          <!-- Dates -->
          <!-- <template v-slot:item.dateCreated="{ item }">
            <span class="grey--text text--darken-2">{{ item.dateCreated || "-" }}</span>
          </template>

          <template v-slot:item.dateChanged="{ item }">
            <span class="grey--text text--darken-2">{{ item.dateChanged || "-" }}</span>
          </template>

          <template v-slot:no-data>
            <div class="pa-6 text-center grey--text">No protocols found</div>
          </template> -->
        </v-data-table>

        <!-- Footer / Pagination -->
        <div class="d-flex align-center justify-space-between px-4 py-3 footer-bar">
          <div class="text-caption grey--text">
            Showing {{ showingFrom }}-{{ showingTo }} of {{ filteredItems.length }} protocols
          </div>

          <div class="d-flex align-center" style="gap: 10px;">
            <v-btn icon small text elevation="0" :disabled="page <= 1" @click="page--">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <div class="text-caption grey--text text--darken-2">
              Page {{ page }} of {{ totalPages }}
            </div>

            <v-btn icon small text elevation="0" :disabled="page >= totalPages" @click="page++">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-container>

        <!-- Create / Edit Protocol Dialog -->
    <v-dialog v-model="dialog.open" max-width="720" persistent >
      <v-card class="dialog-card">
        <v-btn
          icon
          class="dialog-close-btn"
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- Title -->
        <v-card-title class="pb-0">
          <span class="text-h4 font-weight-bold">
            {{ dialog.mode === 'create' ? $t('DriverManagement.buttonNewInterface') : $t('DriverManagement.buttonEditInterface') }}
          </span>
        </v-card-title>

        <v-divider class="mt-1" />

          <!-- Content -->
          <v-card-text>
            <v-form ref="interfaceForm" v-model="dialog.valid" lazy-validation>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.interfaceCode"
                    :label="$t('DriverManagement.InterfaceCD')"
                    outlined dense
                    :rules="[rules.required]"
                    :disabled="dialog.mode === 'edit'"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.interfaceName"
                    :label="$t('DriverManagement.InterfaceName')"
                    outlined dense
                    :rules="[rules.required]"
                  />
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.interfaceType"
                    :label="$t('DriverManagement.InterfaceType')"
                    outlined dense
                    :rules="[rules.required]"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.category"
                    :label="$t('DriverManagement.category')"
                    outlined dense
                    :rules="[rules.required]"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.protocol"
                    :label="$t('DriverManagement.protocol')"
                    outlined dense
                    :rules="[rules.required]"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.connectionMode"
                    :label="$t('DriverManagement.connectionMode')"
                    outlined dense
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.ipAddress"
                    :label="$t('DriverManagement.ipAddress')"
                    outlined dense
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.ipPort"
                    :label="$t('DriverManagement.ipPort')"
                    outlined dense
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider />

          <!-- Actions -->
          <v-card-actions class="dialog-actions">
            <v-spacer />
            <v-btn text @click="closeDialog">
              {{this.$t('cancel')}}
            </v-btn>
            <v-btn
              color="primary"
              :loading="dialog.loading"
              @click="saveInterface"
            >
              {{this.$t('save')}}
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'DriverManagement',

  data () {
    return {
      search: '',
      page: 1,
      itemsPerPage: 20,
      items: [],

      dialog: {
        open: false,
        mode: 'create', // create | edit
        valid: true,
        loading: false
      },
      form: {
        interfaceSkey: '',
        interfaceCode: '',
        interfaceName: '',
        interfaceType: '',
        category: '',
        protocol: '',
        connectionMode: '',
        ipAddress: '',
        ipPort: '',
        isActive: null,
        userCreated: '',
      },
      rules: {
        required: v => !!v || 'Required'
      },
    }
  },

  created () {
    // ✅ Vue2: เรียกตอน component ถูกสร้าง
    this.fetchItems()
  },

  computed: {
    getheaders () {
      return [
        { text: '#', value: 'no', width: 40 },
        { text: 'Actions', value: 'actions', sortable: false, width: 120, align: 'center' },
        { text: this.$t('DriverManagement.InterfaceCD'), value: 'interfaceCode' },
        { text: this.$t('DriverManagement.InterfaceName'), value: 'interfaceName' },
        { text: this.$t('DriverManagement.InterfaceType'), value: 'interfaceType' },
        { text: this.$t('DriverManagement.category'), value: 'category' },
        { text: this.$t('DriverManagement.protocol'), value: 'protocol' },
        { text: this.$t('DriverManagement.connectionMode'), value: 'connectionMode' },
        { text: this.$t('DriverManagement.ipAddress'), value: 'ipAddress' },
        { text: this.$t('DriverManagement.ipPort'), value: 'ipPort' },
      ]
    },
    filteredItems () {
      const q = (this.search || '').trim().toLowerCase()
      if (!q) return this.items

      return this.items.filter(x => {
        return (
          String(x.interfaceCode || '').toLowerCase().includes(q) ||
          String(x.interfaceName || '').toLowerCase().includes(q) ||
          String(x.ipAddress || '').toLowerCase().includes(q)
        )
      })
    },

    totalPages () {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.itemsPerPage))
    },
    showingFrom () {
      if (this.filteredItems.length === 0) return 0
      return (this.page - 1) * this.itemsPerPage + 1
    },
    showingTo () {
      return Math.min(this.page * this.itemsPerPage, this.filteredItems.length)
    }
  },

  watch: {
    search () { this.page = 1 },
    filteredItems () { if (this.page > this.totalPages) this.page = this.totalPages }
  },

  methods: {
    closeDialog () {
      this.dialog.open = false
      if (this.$refs.clientForm) {
        this.$refs.clientForm.resetValidation()
      }
    },
    transportColor (t) {
      const v = String(t || '').toUpperCase()
      if (v === 'HTTP') return 'blue'
      if (v === 'TCP') return 'indigo'
      if (v === 'SERIAL') return 'teal'
      if (v === 'WS' || v === 'WEBSOCKET') return 'deep-purple'
      if (v === 'FILE') return 'grey'
      return 'primary'
    },
    async fetchItems () {
      this.listLoading = true
      this.listError = ''

      try {
        const endpoint = process.env.VUE_APP_API + '/api/' + process.env.VUE_APP_API_VERSION + '/drvierManagement'

        const res = await this.axios.get(endpoint)
        const payload = res.data || {}
        const rows = payload.data || []

        this.items = rows.map(x => {
          return {
            interfaceSkey: x.interface_skey || null,
            interfaceCode: x.interface_cd || '',
            interfaceName: x.interface_name || '',
            interfaceType: x.interface_type || '',
            category: x.category || '',
            protocol: x.protocol || '',
            connectionMode: x.connection_mode || '',

            ipAddress: x.ip_address || '',
            ipPort: x.ip_port || null,

            comPort: x.com_port || null,
            baudRate: x.baud_rate || null,
            parity: x.parity || null,
            stopBits: x.stop_bits || null,
            dataBits: x.data_bits || null,

            httpMethod: x.http_method || null,
            endpointUrl: x.endpoint_url || null,

            isActive: x.is_active === true || x.is_active === 1,
            isOnline: x.is_online === true || x.is_online === 1,

            lastOnline: x.last_online || null,
            samplesProcessed: x.samples_processed || 0,
            lastUpdate: x.last_update || null,

            analyzerCategory: x.analyzer_category || '',
            deviceIcon: x.device_icon || null,

            dateCreated: x.date_created || null,
            userCreated: x.user_created || '',
            dateChanged: x.date_changed || null,
            userChanged: x.user_changed || ''
          }
        })

        this.page = payload.page || 1
        this.total = payload.total || this.items.length
      } catch (err) {
        console.log(err)
        this.listError =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          'Unknown error'
      } finally {
        this.listLoading = false
      }
    },
    async saveInterface () {
      const ok = this.$refs.interfaceForm.validate()
      if (!ok) return

      this.dialog.loading = true

      try {
        const apiBase = process.env.VUE_APP_API
        const apiVersion = process.env.VUE_APP_API_VERSION

        const payload = {
          interface_cd: this.form.interfaceCode,
          interface_name: this.form.interfaceName,
          interface_type: this.form.interfaceType,
          category: this.form.category,
          protocol: this.form.protocol,
          connection_mode: this.form.connectionMode,
          ip_address: this.form.ipAddress,
          ip_port: this.form.ipPort,
          is_active: 1,
          user_created: 'admin'
        }

        let endpoint = ''
        let method = 'post'

        if (this.dialog.mode === 'create') {
          endpoint = `${apiBase}/api/${apiVersion}/register_device_interface`
        } else {
          endpoint = `${apiBase}/api/${apiVersion}/update_device_interface`
          payload.interface_skey = this.form.interfaceSkey
        }

        const res = await this.axios({
          method,
          url: endpoint,
          data: payload,
          validateStatus: () => true
        })

        if (!res.data || !res.data.isSuccess) {
          throw new Error(res.data?.message || 'Save failed')
        }

        await this.$swal({
          type: 'success',
          title: this.dialog.mode === 'create'
            ? 'Protocol created'
            : 'Protocol updated'
        })

        this.dialog.open = false
        await this.fetchItems()
      } catch (e) {
        await this.$swal({
          type: 'error',
          title: e.message || 'Save failed'
        })
      } finally {
        this.dialog.loading = false
      }
    },
    openCreateInterface () {
      this.dialog.mode = 'create'
      this.dialog.open = true
      this.form = {
        interfaceSkey: null,
        interfaceCode: '',
        interfaceName: '',
        interfaceType: '',
        category: '',
        protocol: '',
        connectionMode: '',
        ipAddress: '',
        ipPort: '',
      }
      this.$nextTick(() => {
        this.$refs.interfaceForm && this.$refs.interfaceForm.resetValidation()
      })
    },
    openEditInterface (item) {
      this.dialog.mode = 'edit'
      this.dialog.open = true

      this.form = {
        interfaceSkey: item.interfaceSkey,
        interfaceCode: item.interfaceCode,
        interfaceName: item.interfaceName,
        interfaceType: item.interfaceType,
        category: item.category,
        protocol: item.protocol,
        connectionMode: item.connectionMode,
        ipAddress: item.ipAddress,
        ipPort: item.ipPort,
      }

      this.$nextTick(() => {
        this.$refs.interfaceForm && this.$refs.interfaceForm.resetValidation()
      })
    },
    async confirmDeleteDriver (item) {
      const interfaceSkey = item.interfaceSkey || item.interface_skey
      if (!interfaceSkey) {
        await this.$swal({ type: 'error', title: this.$t('Error'), text: 'interface_skey is missing' })
        return
      }

      // 1) confirm
      const result = await this.$swal({
        text: this.$t('DriverManagement.confirmDeleteDriver'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('delete'),
        cancelButtonText: this.$t('cancel')
      })
      const confirmed = result === true || (result && result.value)
      if (!confirmed) return

      // 2) loading
      this.$swal({
        title: this.$t('Processing...'),
        text: this.$t('Please wait'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => this.$swal.showLoading()
      })

      try {
        const endpoint =
          `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_API_VERSION}` +
          `/delete_device_interface/${encodeURIComponent(interfaceSkey)}`

        const res = await this.axios.delete(endpoint)

        if (!res?.data?.isSuccess) {
          throw new Error(res?.data?.message || 'Delete failed')
        }

        // 3) ลบแถวออกจาก UI ทันที (ไม่ต้อง fetch ใหม่)
        const idx = this.items.findIndex(i => (i.interfaceSkey || i.interface_skey) === interfaceSkey)
        if (idx !== -1) this.items.splice(idx, 1)

        await this.$swal({
          type: 'success',
          title: this.$t('Delete Success'),
          text: this.$t('DriverManagement.deleteSuccess')
        })
      } catch (e) {
        await this.$swal({
          type: 'error',
          title: this.$t('Delete failed'),
          text: e?.message || String(e)
        })
      }
    },
  }
}
</script>
<style>
.dialog-card {
  position: relative;
  border-radius: 12px;
}

.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  min-width: 36px !important;
  border-radius: 50%;
}
.dialog-actions {
  padding: 16px 24px;
}
</style>